import { useQuery } from '@mint-lib/query-client';
import { ApprovalFlows } from '@mint-sdk/api-approval-flows';

type Options = {
  enabled: boolean;
};

const useAvailableFlowListData = ({ enabled }: Options) => {
  return useQuery({
    ...ApprovalFlows.listAvailableFlows({}),
    enabled,
    staleTime: Infinity,
  });
};

export default useAvailableFlowListData;
